import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user && user.role === "admin") nav("/admin/painel"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      nav("/admin/painel");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen ci-bg-grid flex items-center justify-center px-4">
      <form onSubmit={submit} className="ci-card p-8 w-full max-w-md" data-testid="admin-login-form">
        <div className="flex flex-col items-center mb-6">
          <img src="/logo.png" alt="Club Infinity" className="h-16 w-16 object-contain mb-3" />
          <h1 className="text-xl font-bold">Painel Administrativo</h1>
          <p className="text-sm text-gray-400">Club Infinity — Área restrita</p>
        </div>
        {error && <div className="mb-4 text-sm text-red-300 bg-red-500/10 border border-red-500/30 rounded-lg px-3 py-2" data-testid="admin-login-error">{error}</div>}
        <label className="block text-sm text-gray-400 mb-1">Email</label>
        <input data-testid="admin-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
          className="w-full bg-[#0B0F17] border border-white/10 focus:border-cyan-400/60 rounded-lg px-4 py-3 mb-4 outline-none" />
        <label className="block text-sm text-gray-400 mb-1">Senha</label>
        <input data-testid="admin-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
          className="w-full bg-[#0B0F17] border border-white/10 focus:border-cyan-400/60 rounded-lg px-4 py-3 mb-6 outline-none" />
        <button type="submit" disabled={loading} data-testid="admin-login-submit"
          className="ci-btn-gold w-full flex items-center justify-center gap-2 py-3 rounded-lg font-bold hover:brightness-105 transition disabled:opacity-60">
          <Lock className="w-4 h-4" /> {loading ? "Entrando..." : "Entrar"}
        </button>
      </form>
    </div>
  );
}
